import { render, staticRenderFns } from "./DTSHEdit.vue?vue&type=template&id=d3781650&"
import script from "./DTSHEdit.vue?vue&type=script&lang=js&"
export * from "./DTSHEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports